import { Alert, Platform } from 'react-native'

const alertWeb = (title, description, options, extra) => {
    const result = window.confirm([title, description].filter(Boolean).join('\n'))

    if (result) {
        const confirmOption = options.find(({ style }) => style !== 'cancel')
        confirmOption && confirmOption.onPress()
    } else {
        const cancelOption = options.find(({ style }) => style === 'cancel')
        cancelOption && cancelOption.onPress()
    }
}

const AlertCustom = (Platform.OS === 'web') ? alertWeb : Alert.alert

export default AlertCustom;